// src/types/properties/RentalType.ts
var RentalTypeEnum = /* @__PURE__ */ ((RentalTypeEnum2) => {
  RentalTypeEnum2["FullHouse"] = "full_house";
  RentalTypeEnum2["IndividualListings"] = "individual_listings";
  return RentalTypeEnum2;
})(RentalTypeEnum || {});
var INDIVIDUAL_LISTING_BLACKLIST = [
  "studio" /* Studio */,
  "bungalow" /* Bungalow */,
  "cabin" /* Cabin */,
  "chalet" /* Chalet */,
  "cottage" /* Cottage */
];
var MULTI_UNIT_ONLY = [
  "hotel" /* Hotel */,
  "boutique_hotel" /* BoutiqueHotel */,
  "guesthouse" /* Guesthouse */
];

export {
  RentalTypeEnum,
  INDIVIDUAL_LISTING_BLACKLIST,
  MULTI_UNIT_ONLY
};
